




import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class ActivitySpinner extends Vue {
  // empty
}
